import { isArray } from 'lodash';
import { removeNulls } from 'utils';
export function validateDeviceConfig(config) {
    if (!config) {
        return null;
    }
    const validated_config = isArray(config) ? config : [config];
    const device_config = removeNulls(validated_config);
    return device_config.length > 0 ? device_config : null;
}
